import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { curationsApiPath } from './apiPath';

const DeleteCurationRequestSchema = z
  .object({
    curationId: z.string(),
  })
  .describe('DeleteCurationRequestSchema');

const DeleteCurationResponseDataSchema = z
  .object({
    data: z.null(),
  })
  .describe('DeleteCurationResponseSchema');

export type DeleteCurationRequest = z.infer<typeof DeleteCurationRequestSchema>;
export type DeleteCurationResponseData = z.infer<typeof DeleteCurationResponseDataSchema>;
export type DeleteCurationResponse = MusinsaStandardResponse<DeleteCurationResponseData>;

export const deleteCuration = (params: DeleteCurationRequest) =>
  executeStandardRequest(() =>
    privateHttpClient.delete<DeleteCurationResponse>(
      curationsApiPath.deleteCuration(params.curationId),
    ),
  );
